<template>
    <v-row>
        <v-col cols="12">
            <v-row class="mx-1 my-2">
                <v-col cols="12">
                    <Waiver 
                        v-if="userStore"
                        ref="waiverYou"
                        :peopleSignatory="userStore"
                        :waiver="waiverItemIndex"
                        :viewBtnNext="true"
                        @showSnackBar="({msg, color}) => $emit('showSnackBar', {msg, color})"
                        @nextSignItem="nextSignItem"
                        @backWaiver="backWaiver"
                        :viewBtnBack="index > 0"
                    />
                </v-col>
            </v-row>
            <v-row class="ml-1 mr-1">
                <v-col md="6" class="text-left">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white"
                        @click="$emit('backStep')"
                    >{{ $t("common.prev") }}</v-btn>
                </v-col>
                <v-col md="6" class="text-right">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white"
                        @click="next"
                    >{{ $t("common.next") }}</v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { 
    VRow, VCol, VBtn
} from 'vuetify/lib';
import Waiver from "@/components/waiver/WaiverTemplate";
import { mapState } from "vuex";
import axios from "axios";

export default {
    components: {
        VRow, VCol, VBtn,
        Waiver
    },
    props: {
        waivers: Array,
        currentIp: { type: String, default: "" },
        bandStep5: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            buttonColor: "#000",
            waiverList: [],
            bandApprove: false,
            index: 0
        }
    },
    computed: {
        ...mapState({
            userStore: (state) => state.session.user
        }),
        waiverItemIndex() {
            this.waivers.forEach((el) => {
                if(this.userStore.id == el.userId) {
                    const item = this.waiverList.find((el1) => {
                        return el.id == el1.id;
                    });
                    if(!item) {
                        this.waiverList.push({
                            ...el,
                            statusReview: el.waiverStatus == "Signed"
                        });
                    }
                }
            });
            if(this.index >= 0 && this.index < this.waiverList.length) {
                return this.waiverList[this.index];
            }
            return false;
        }
    },
    created() {
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    mounted() {},
    methods: {
        next() {
            let bandNext = false;
            if(this.$refs.waiverYou) {
                bandNext = this.$refs.waiverYou.nextSign();
            }
            if(!bandNext) {
                this.$emit('showSnackBar', { msg: this.$t("eventWaiver.invalid_step_4"), color: "error" });
                return;
            }
            if(this.bandStep5) {
                this.$emit('nextStep');
            } else {
                this.$emit('submitWaiver');
            }
            
        },
        async nextSignItem() {
            const data = new FormData();
            data.append("eventWaiverSignedId", this.waiverItemIndex.id);
            const waiverForm = this.$refs.waiverYou;
            data.append("iAgree", waiverForm.timeIAgree);
            data.append("isCertify", waiverForm.timeIsCorrect);
            data.append("isConsent", waiverForm.timeIsConsent);
            data.append("signature", waiverForm.signature);
            data.append("waiverStatus", "Signed");
            data.append("ipAddress", this.currentIp);
            data.append("isNegligence", waiverForm.timeIsNegligence);
            data.append("isBoundParticipant", waiverForm.timeIsBoundParticipant);
            data.append("isBoundParent", waiverForm.timeIsBoundParent);
            data.append("isMinor", waiverForm.type === 'Minor' ? 1 : 0);
            data.append("languageCode", waiverForm.language);
            // Snapshot rendered checkbox labels + paragraphs so the signed
            // waiver captures exactly what the signer saw.
            data.append("isAgreedText", waiverForm.timeIAgreeLabel || "");
            data.append("isNegligenceText", waiverForm.timeIsNegligenceLabel || "");
            data.append("isCertifyText", waiverForm.timeIsCorrectLabel || "");
            data.append("isCertifyMinorText", waiverForm.timeIsCorrectMinorLabel || "");
            data.append("isBoundParticipantText", waiverForm.timeIsBoundParticipantLabel || "");
            data.append("isBoundParentText", waiverForm.timeIsBoundParentLabel || "");
            data.append("isConsentText", waiverForm.timeIsConsentLabel || "");
            data.append("voluntarilyText", waiverForm.$t("eventWaiver.voluntarily_text", waiverForm.language));
            data.append("negligenceText", waiverForm.negligenceParagraph || "");
            data.append("boundAgreementText", waiverForm.boundAgreementParagraph || "");
            let axiosConfig = {
                headers: { "content-type": "multipart/form-data" },
            };
            const response = await axios.put(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/waivers/saveSignature`, data, axiosConfig);
            if(response.data.success) {
                this.waiverItemIndex.statusReview = true;
                this.waiverItemIndex.isAgreedChk = response.data.message.isAgreedChk;
                this.waiverItemIndex.isElectronicConsentChk = response.data.message.isElectronicConsentChk;
                this.waiverItemIndex.isCertifyChk = response.data.message.isCertifyChk;
                this.waiverItemIndex.signatureImage = response.data.message.signatureImage;
                if(this.waiverList.filter((el) => !el.statusReview).length == 0) {
                    this.bandApprove = true;
                    if(this.index == (this.waiverList.length - 1)) 
                        this.next();
                    else 
                        this.index++;
                } else {
                    this.index++;
                }
            } else {
                this.$emit('showSnackBar', { msg: this.$t("common.error_general"), color: "error" });
                return;
            }
        },
        backWaiver() {
            if(this.index > 0) this.index--;
        }
    },
    watch: {
        waiverItemIndex(val) {
            const waiver = this.$refs.waiverYou; 
            if(waiver && waiver.$refs.formWaiver) {
                waiver.$refs.formWaiver.resetValidation();
                waiver.loadData(val);
            }
                
        }
    }
}
</script>